var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex flex-center preview-play",on:{"click":_vm.handleClick}},[_c('Icon',{attrs:{"path":"media","name":_vm.playing ? 'play' : 'pause'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }